import { put, call } from "redux-saga/effects";
import get_api from "../api/GetApi";
import { assignAction } from "../actions/index";
import { globalStartLoading, globalFinishLoading } from "modules/actions/Loading/index";

export function* getAssignViewInfoData(param) {
  try {
    yield put(globalStartLoading());
    const { data } = yield call(get_api.getViewInfo, param);

    if (data.data === null) {
      yield put(assignAction.loadAssignViewSuccess(false));
    } else {
      yield put(assignAction.loadAssignViewSuccess(data));
    }
    yield put(globalFinishLoading());
  } catch (error) {
    console.log("from saga  -> ");
    console.log(error);
    yield put(assignAction.loadAssignViewFail(error));
    yield put(globalFinishLoading());
  }
}
